import { render, staticRenderFns } from "./DiskArraySimpleTable.vue?vue&type=template&id=e543a442"
import script from "./DiskArraySimpleTable.vue?vue&type=script&lang=js"
export * from "./DiskArraySimpleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports